export default __webpack_public_path__ + "static/media/balanceSuccess.5e9f919b.png";